import { Router } from '@angular/router';
import { EReducers, IReducers } from './../reducers/index';
import { Store } from '@ngrx/store';
import { IUserSessionData, UserState } from 'app/store/models/user.model';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { getUserSession } from '../actions/user.action';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  ready: BehaviorSubject<IUserSessionData>;

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private store: Store<IReducers>,
    private router: Router,
  ) {
  }

  isImpersonating(): boolean {
    let oldTokensData = localStorage.getItem('oldTokens');

    try {
      oldTokensData = JSON.parse(oldTokensData);
    } catch (e) {
      console.error(e);
    }

    if (Array.isArray(oldTokensData) && oldTokensData.length === 0) {
      return false;
    }

    return !!oldTokensData;
  }

  onReady(): Observable<IUserSessionData> {
    if (!this.ready) {
      // @ts-ignore
      return of({});
    }
    return this.ready.asObservable();
  }

  loadUserSession() {
    this.ready = new BehaviorSubject<IUserSessionData>(undefined);
    this.store
      .select(EReducers.USER)
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged((x, y) => {
          if (x.sessionData === undefined || y.sessionData === undefined) {
            return false;
          }

          return (
            JSON.stringify(x.sessionData) === JSON.stringify(y.sessionData)
          );
        }),
      )
      .subscribe((state: UserState) => {
        if (!state.loggedIn && window.location.pathname !== '/login') {
          if (environment.production) {
            window.location.href = 'https://retreva.com';
            return;
          }
          this.router.navigate(['/login']);
          return;
        }

        if (state.sessionData === undefined) {
          this.store.dispatch(getUserSession());
          return;
        } else {
          this.ready.next(state.sessionData);
        }
      });
  }

  destroySession() {
    this.destroy$.next(false);
  }
}
